import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: '',
            hour: '',
            affid: null,
            country: null,
            subid: null,
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm();
        const filters = Object.assign({}, this.state);

        if(isValid) this.props.onSubmit(filters, type);
    }

    validateForm() {
        const { day } = this.state;

        let alert = null;

        if(!day) alert = 'Please set Day';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="number"
                            name="hour"
                            label="Hour:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hour}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('affid')}>Load Affid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('subid')}>Load Subid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('country')}>Load Country</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('all')}>Load All</Button>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit('')}>Load Report</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerHourly/components/Form/index.js